import Content from "./Content";
import ContentFactory from "./ContentFactory";

const { default: ContentTypes } = require("./ContentTypes");
const { default: ENGLanguagePackContentType } = require("./ENGLanguagePackContentType");

/**
* ImageContent.js
* 
* Created on 10-okt-2013, 18:37:03
*
* @author Ivo Swartjes for Ranj
**/
export default class ImageContent extends Content {
    constructor(languagePack, contentID, image, label) {
        super(ImageContent.NAME, ContentTypes.TYPE_IMAGE, label, languagePack, contentID);
        this.image = image;
    }

    remove() {
        this.removeLanguagePackContent(ImageContent.IMAGE_LABEL, ENGLanguagePackContentType.IMAGE);
        super.remove();
    }

    clone() {
        const clone = ContentFactory.getContent(ContentTypes.TYPE_IMAGE, this.getLanguagePack());
        clone.setContentID(this.getContentID());
        clone.setImage(this.getImage());
        return clone;
    }

    getImage() {
        return this.getLanguagePackContent(ImageContent.IMAGE_LABEL, ENGLanguagePackContentType.IMAGE);
    }

    setImage(value) {
        this.setLanguagePackContent(ImageContent.IMAGE_LABEL, ENGLanguagePackContentType.IMAGE, value);
    }

    convertToObject() {
        return this.getObject([]);
    }
}

ImageContent.NAME = "Image";
ImageContent.TYPE = "engImageContent";
ImageContent.IMAGE_LABEL = "image";


